import * as React from "react"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import ChaptersMap from "../../components/sections/chapters-map/map"
import Breadcrumbs from "../../components/breadcrumbs"
import * as styles from "./chapters.module.css"

import { useState } from "react"
import { Box, Circle, PenTool } from "react-feather"
import { graphql, Link, useStaticQuery } from "gatsby"
import PageTitle from "../../components/sections/page-title/page-title"
import ChaptersMapEditable from "../../components/sections/chapters-map/map-editable"

const ChaptersPage = () => {
  const { allContentfulChapter } = useStaticQuery(graphql`{
    allContentfulChapter {
      nodes {
        address
        basedOn
        city
        state
        country
        location {
          lat
          lon
        }
        type
        status
        title
        website
        email
        chapterSince(formatString: "DD MMM YYYY")
      }
    }
  }`);

  return (
    <Layout>
      <PageTitle
        title={`Our Chapters`}
        description={`There are ${allContentfulChapter.nodes.length} SIGCHI chapters on 6 continents in 36 different countries, nurturing new connections among chapter members and across chapters. We are seeking to expand the geographical coverage of SIGCHI Chapters - contact us at sigchi-vp-chapters@acm.org to find out more.`}
        crumbs={[
          { title: `Home`, link: `/` },
          { title: `People`, link: `` },
          { title: `Chapters`, link: `` },
        ]}
        type={`white`}
      />
      <ChaptersMapEditable MapAcess={process.env.GATSBY_MAPBOX}/>
      <section className={`xl`}>
        <div className={`wrapped-content`}>
          <h2>Chapters by Theme</h2>
          <div className={styles.chapterWrap}>
            {allContentfulChapter.nodes.map(chapter => ( chapter.basedOn === 'Theme' &&
              <div className={styles.chapter} key={chapter.title}>
                {/* {t.icon === `meta` && <div className={styles.icon}><Circle size={`3rem`}/></div>}
                {t.icon === `art` && <div className={styles.icon}><PenTool size={`3rem`}/></div>}
                {t.icon === `xr` && <div className={styles.icon}><Box size={`3rem`}/></div>} */}
                <h4 className={styles.title}>{chapter.title}</h4>
                <p className={styles.type}>{chapter.type}</p>
                <p className={styles.contact}>Contact: {chapter.email}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={`grey`}>
        <div className={`custom-content`}>
          <h2>About the Chapters</h2>
          <p>Every chapter has its own unique approach, organizing conferences, symposia, meetings, seminars, summer schools, book clubs, networking opportunities, discussion forums, job boards, community outreach, design challenges and other special events year-round. Many chapters host their own local conferences and hold contests for HCI students.</p>
        </div>
      </section>
      <section>
        <div className={`custom-content`}>
          <h2>How to start a SIGCHI Chapter?</h2>
          <p>You can start your ACM SIGCHI Chapter by filling out the form to <Link to="https://services.acm.org/public/chapters/AutoChap/">Start a New Chapter</Link>. You will need to supply the following information:</p>
          <p>
            <b>Step 1</b>: Enter chapter name, chapter email address, chapter type, and
            chapter sub-type.
          </p>
          <p>
            <b>Step 2</b>: Enter the names of three individuals to serve as Chair,
            Vice-Chair, and Treasurer. These individuals must have an ACM
            Professional Membership and relevant SIG Membership.
          </p>
          <p>
            <b>Step 3</b>: Enter chapter contact information (postal address and phone
            number).
          </p>
          <p>
            <b>Step 4</b>: Enter the names of at least ten (10) individuals willing to
            carry out the chapter's mission and participate in activities. The
            last name, first name, and email addresses of these members will be
            required through the automated chartering application.
          </p>
          <p>
            Note: Following information is necessary to complete the form. ACM
            membership numbers of Chair, Vice-Chair, Treasurer, contact email of
            the new chapter (a new email account is recommended), communication
            address, phone number, name and email addresses of at least 10
            members
          </p>
        </div>
      </section>
    </Layout>
  )
}

export const Head = () => <Seo title="Chapters" />

export default ChaptersPage
